
<div #userInformation [ngClass]="{'dark': (darkmode.isDarkMode | async), 'light': !(darkmode.isDarkMode | async)}">
  <div class="userInformation">
    <div class="heading">
      <div class="circle user-circle">
        {{employeeInformationPosition?.employee?.firstName?.charAt(0)}}{{employeeInformationPosition?.employee?.lastName?.charAt(0)}}
      </div>
      <h3>{{employeeInformationPosition?.employee?.firstName}} {{employeeInformationPosition?.employee?.lastName}}</h3>
    </div>
    <div class="contact">
      <h4>Kontakt</h4>

      <table>
        @if (employeeInformationPosition?.employee?.eMail) {
          <tr>
            <td>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M464 64C490.5 64 512 85.49 512 112C512 127.1 504.9 141.3 492.8 150.4L275.2 313.6C263.8 322.1 248.2 322.1 236.8 313.6L19.2 150.4C7.113 141.3 0 127.1 0 112C0 85.49 21.49 64 48 64H464zM217.6 339.2C240.4 356.3 271.6 356.3 294.4 339.2L512 176V384C512 419.3 483.3 448 448 448H64C28.65 448 0 419.3 0 384V176L217.6 339.2z"/></svg>
            </td>
            <td>
              <a [href]="'mailto:' + employeeInformationPosition?.employee?.eMail">{{employeeInformationPosition?.employee?.eMail}}</a>
            </td>
          </tr>
        }
        @if (employeeInformationPosition?.employee?.telefone) {
          <tr>
            <td>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M511.2 387l-23.25 100.8c-3.266 14.25-15.79 24.22-30.46 24.22C205.2 512 0 306.8 0 54.5c0-14.66 9.969-27.2 24.22-30.45l100.8-23.25C139.7-2.602 154.7 5.018 160.8 18.92l46.52 108.5c5.438 12.78 1.77 27.67-8.98 36.45L144.5 207.1c33.98 69.22 90.26 125.5 159.5 159.5l44.08-53.8c8.688-10.78 23.69-14.51 36.47-8.975l108.5 46.51C506.1 357.2 514.6 372.4 511.2 387z"/></svg>
            </td>
            <td>
              <a [href]="'tel:' + employeeInformationPosition?.employee?.telefone">{{employeeInformationPosition?.employee?.telefone}}</a>
            </td>
          </tr>
        }
        @if (employeeInformationPosition?.employee?.handy) {
          <tr>
            <td>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M320 0H64C37.5 0 16 21.5 16 48v416C16 490.5 37.5 512 64 512h256c26.5 0 48-21.5 48-48v-416C368 21.5 346.5 0 320 0zM240 447.1C240 456.8 232.8 464 224 464H159.1C151.2 464 144 456.8 144 448S151.2 432 160 432h64C232.8 432 240 439.2 240 447.1zM304 384h-224V64h224V384z"/></svg>
            </td>
            <td>
              <a [href]="'tel:' + employeeInformationPosition?.employee?.handy">{{employeeInformationPosition?.employee?.handy}}</a>
            </td>
          </tr>
        }
        @if (employeeInformationPosition?.employee?.fax) {
          <tr>
            <td>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M192 64h197.5L416 90.51V160h64V77.25c0-8.484-3.375-16.62-9.375-22.62l-45.25-45.25C419.4 3.375 411.2 0 402.8 0H160C142.3 0 128 14.33 128 32v128h64V64zM64 128H32C14.38 128 0 142.4 0 160v320c0 17.62 14.38 32 32 32h32c17.62 0 32-14.38 32-32V160C96 142.4 81.63 128 64 128zM480 192H128v288c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32V224C512 206.4 497.6 192 480 192zM288 432c0 8.875-7.125 16-16 16h-32C231.1 448 224 440.9 224 432v-32C224 391.1 231.1 384 240 384h32c8.875 0 16 7.125 16 16V432zM288 304c0 8.875-7.125 16-16 16h-32C231.1 320 224 312.9 224 304v-32C224 263.1 231.1 256 240 256h32C280.9 256 288 263.1 288 272V304zM416 432c0 8.875-7.125 16-16 16h-32c-8.875 0-16-7.125-16-16v-32c0-8.875 7.125-16 16-16h32c8.875 0 16 7.125 16 16V432zM416 304c0 8.875-7.125 16-16 16h-32C359.1 320 352 312.9 352 304v-32C352 263.1 359.1 256 368 256h32C408.9 256 416 263.1 416 272V304z"/></svg>
            </td>
            <td>
              <a>{{employeeInformationPosition?.employee?.fax}}</a>
            </td>
          </tr>
        }
      </table>
    </div>
  </div>
  <div class="distance" style="height: 10px;"></div>
</div>